import BSelect from "@/components/singles/BSelect/component.vue";

export default {
  name: "",
  components: {
    BSelect
  },
  props: ["includeExpired"],
  data() {
    return {
      form: {
        valid: false,
        select: {
          name: "cards",
          nameProp: "card.desc",
          title: "Select card",
          selected: null,
          order: "created",
          validation: "required",
          items: []
        }
      }
    };
  },
  computed: {},
  async created() {
    await this.GetItems();
  },
  async mounted() {},
  methods: {
    Select(selected) {
      this.form.select.selected = selected;
      this.$emit("selected", selected);
    },

    IsCardExpired(month, year) {
      let currDate = new Date();
      let cardDate = new Date();
      cardDate.setFullYear(year);
      cardDate.setMonth(month);

      if (currDate > cardDate) {
        return true;
      } else {
        return false;
      }
    },

    async GetItems() {
      let items = await this.$helpers.PostApi("get/paymentMethods");

      items = items.map(x => {
        x.card.desc = `${x.card.brand.toUpperCase()} **** **** **** ${
          x.card.last4
        }, expire ${x.card.exp_month}/${x.card.exp_year}`;
        x.card.expired = this.IsCardExpired(x.card.exp_month, x.card.exp_year);

        return x;
      });

      if (this.includeExpired) {
        this.form.select.items = items;
      } else {
        this.form.select.items = items.filter(x => !x.card.expired);
      }

      if (items.length === 0) {
        this.$emit("empty", true);
      } else {
        this.$emit("empty", false);
      }
    }
  }
};
